import { render, staticRenderFns } from "./newest.vue?vue&type=template&id=334e0df3"
import script from "./newest.vue?vue&type=script&lang=js"
export * from "./newest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports